// 新模板的统一核保
// import { InsurStore,InsurMutations } from '@/views/stencil/detail/store'
import { insuranceCheck,insurancePlaceOrder, installmentCheckAndConfirm } from '@/model/javaApi/detail.js'
import { CacheModule } from '@/utils/commonUtils'
import { combination } from '@/utils/regular.js'
import { rateCost } from '@/model/javaApi/detail.js'
import { toApp } from '@/utils/appBridge'


export default{
    computed:{
        // 渠道商品code
        channelCommodityCode(){
            return this.$route.query.channelCommodityCode
        },
    },
    methods:{
        // 规则校验
        TXverifyRules(rule = {},value = ''){
            if(value.length > 0){
                if(new RegExp("[*]").test(value)){   // 如果是加密数据则不校验
                    return true
                }else{   // 不加密的进行规则校验
                    const result = combination(rule.inputLimit,value);
                    if(result && !(value.length - rule.max > 0)  ){
                        return true
                    }else{
                        return false
                    }
                }
                
            }else{
                return true 
            }
        },
        // 投保校验
        //   data 投保信息 
        //   checked 是否勾选协议
        verification(data,checked = true){
            let { elements:fromPageData, ...rest } = data;
            // 格式化
            let elementEnums = new Array;
            (Object.keys(fromPageData)).forEach(key => {
                let obj = {
                "elementEnums": fromPageData[key].elementEnums,
                "option": fromPageData[key].last, // 选中值
                "price": fromPageData[key].price,
                "serviceCode": fromPageData[key].elementCode,
                "serviceName": fromPageData[key].elementName,
                "value": fromPageData[key].value,
                "showName":fromPageData[key].showName,
                "isRequired":fromPageData[key].isRequired,
                "rules":fromPageData[key].rules,
                "readonly":fromPageData[key].readonly,
                }
                elementEnums.push(obj)
            })

            return new Promise((resolve,reject)=>{
                try {
                    elementEnums.forEach(item =>{
                        
                        if(!item.readonly){ // 是否为只读
                            if(item.isRequired && !item.value){ // 必填校验
                                throw('请输入'+item.showName);
                            }else if(item.rules && item.value){ // 规则校验
                                if(!this.TXverifyRules(item.rules,item.value)){
                                    throw('请输入正确的'+item.showName);
                                }
                            }
                        }
                        
                    })
                    this.$refs.InstructionProtocol.checkSelectFlag().then((bol)=>{
                        if(bol){
                            let insurancePostData = {
                                elements:elementEnums,
                                ...rest
                            }
                            console.log(rest.yfbInsuranceUniqueId, '我是rest');
                            // 分期保险
                            if(rest.yfbInsuranceUniqueId){
                                // 存储投保参数
                                this.setPostData(insurancePostData)
                                resolve()
                            }else{
                                //之前逻辑
                                insuranceCheck(insurancePostData).then(res =>{
                                    if(res.result){
                                        insurancePostData.proposalOrderNo = res.proposalOrderNo;
                
                                        // 存储投保参数
                                        this.setPostData(insurancePostData)
                                        // 执行后续操作
                                        resolve(res)
                                    }else{
                                        reject(`核保result:${res.result}`)
                                        // console.log('result为false，不进行跳转。')
                                    }
                                }).catch((err)=>{
                                    reject(err)
                                    this.setPostData(null)
                                }).finally(()=>{
                                    // next()
                                })
                            }
                        }else{
                            this.$refs.newProtocol.modeShow=true
                            console.log('请认真阅读并勾选条款须知')
                        }
                    }).catch(err=>{
                        console.log(err)
                    })
                } catch (e) {
                    this.$toast(e)
                }
            })


            
            
        },
        // 算费金额
        // fromPageData 投保信息
        // productCode 产品code
        async getRateResult(fromPageData,productCode){ 
            //拿到算费因子 
            let selectItems = []; 
            try {
                (Object.keys(fromPageData)).forEach(key => {
                    // 如果是算费因子 
                    if(fromPageData[key].isCount){
                        let data = {
                            elementEnum: fromPageData[key].elementEnums,
                            isCount: fromPageData[key].isCount? 1:0,
                            optionCode: fromPageData[key].elementCode,
                            optionName:fromPageData[key].elementName,
                            optionLast:fromPageData[key].last,
                            optionValue: fromPageData[key].value,
                            ruleEnum: fromPageData[key].ruleEnums,
                        }
                        selectItems.push(data)
                        // 有规则存在 && 值不为空时先校验规则 再去请求试算
                        if(fromPageData[key].rules && fromPageData[key].value){
                            // 规则校验
                            if(!this.TXverifyRules(fromPageData[key].rules,fromPageData[key].value)){
                                throw('请输入正确的'+fromPageData[key].showName);
                            }
                        }
                    }
                    
                });
                // 请求金额
                const postData = {
                    "productCode": productCode,
                    "selectItems": selectItems
                }
                console.log('算费接口请求参数',postData)
                let result = await this.toRateCost(postData)
                return result
            } catch (e) {
                Vue.$toast(e)
            }
            
            
        },
        // 算费 
        toRateCost(postData){
            return new Promise((resolve,reject)=>{
                rateCost(postData).then((res) => {
                    resolve (res)
                }).catch(res =>{
                    resolve(null)
                    this.$toast(res.message)
                })
            })
        },
        // 存储核保参数
        setPostData(data){
            CacheModule.setSessionStorage('insurancePostData',data)
        },
        // 获取核保参数
        getPostData(){
            return CacheModule.getSessionStorage('insurancePostData')
        },
        // 创建订单
        mixinCreatAnOrder(next) {
            let insuranceParmes = this.getPostData()
            insurancePlaceOrder(insuranceParmes).then(res =>{
                if(!res.orderNo){
                    this.$toast('订单号为空,下单失败');
                    return false
                }
                if (insuranceParmes.price == 0) { //免费
                    if (next) {
                        next()
                    } else { // 节点图
                        this.$router.push({
                            path: "/insured",
                            query: {
                                channelCommodityCode: this.channelCommodityCode,
                                orderNo: res.orderNo, //赠险订单号
                                baseNo: insuranceParmes.baseNo || '',  //主站订单号 ，没有则为空
                                flag: 'postdisable',
                                pid: this.$route.query.pid,
                                ch: this.$route.query.ch
                            }
                        });
                    }
                }else{ // 付费 
                    this.$router.push({
                        path: "/detailPay",
                        query:{
                            outTradeNo:res.orderNo, //订单号
                            baseNo:insuranceParmes.baseNo || '',  //主站订单号 没有则为空
                            flag: 'postdisable',
                            pid:this.$route.query.pid,
                            ch:this.$route.query.ch
                        }
                        
                    });
                }
            }).finally(()=>{
                

            })
        },
        // 创建订单
        mixinInstallmentCreatAnOrder(next) {
            let insuranceParmes = this.getPostData()
            console.log(insuranceParmes, 'insuranceParmes')
            installmentCheckAndConfirm(insuranceParmes).then(res =>{
                next(res.returnUrl||'')
            }).finally(()=>{
            })
        },
        // 赠险确认订单页 返回app 
        mixinToAppPresentInsurance() {
            let insuranceParmes = this.getPostData()
            // 传给app订单号
            toApp('presentInsurance',{
                proposalOrderNo:insuranceParmes.proposalOrderNo, // 核保单号
                insureCode:this.channelCommodityCode, // 商品code
                schemeCode:insuranceParmes.schemeCode // 方案code
            })
        }
    }
}